import { useState } from "react";
import { useModal } from "@ebay/nice-modal-react";
import { t } from "@/i18n-js/instance";
import { FiltersBar } from "@/react/components/SettingsApp/CommunityBot/FiltersBar";
import {
  USAGE_SECTIONS,
  UsageContextProvider,
} from "@circle-react/providers/UsageContext";
import { Modal } from "@circle-react-uikit/ModalV2";
import { ImportModalFooter } from "../ImportModalFooter";
import { ImportModalHeader } from "../ImportModalHeader";
import { useSnippetsForImport } from "../queries";
import { useMultiSelect } from "../useMultiSelect";
import { Snippets } from "./Snippets";
import { CUSTOM_TYPE_OPTIONS } from "./constants";

export const ImportSnippetsModalComponent = ({
  snippetIds,
  onImport,
  page,
}: {
  snippetIds: number[];
  onImport: (ids: number[]) => void;
  page: number;
}) => {
  const modal = useModal();
  const [currentPage, setPage] = useState(page);
  const [filters, setFilters] = useState({
    name: "",
    type: "",
  });

  const snippetsQuery = useSnippetsForImport({
    currentPage,
    snippetIds,
    title: filters.name,
    type: filters.type,
  });
  const {
    selectedIds,
    allIdsOnPage,
    handleCheckboxChange,
    handleSelectAllOnPage,
    reset,
  } = useMultiSelect({ query: snippetsQuery });

  const onChangePage = (page: number) => {
    // Forcing useQuery to only cache one page
    setPage(page);
    snippetsQuery.remove();
  };

  const handleOnImport = () => {
    onImport(selectedIds);
    void modal.hide();
    reset();
  };

  return (
    <UsageContextProvider section={USAGE_SECTIONS.ADMIN}>
      <Modal isOpen={modal.visible} onClose={modal.hide}>
        <Modal.Overlay />
        <Modal.Content
          size="auto"
          className="flex h-full max-h-full max-w-[768px] flex-col overflow-visible !rounded-t-none sm:h-full sm:!rounded-t-lg md:max-h-[80vh] lg:max-w-[992px]"
        >
          <ImportModalHeader
            title={t(
              "community_bot.bot_builder.knowledge_page.custom_resources_table.title",
            )}
          />
          <FiltersBar
            name={filters.name}
            onNameChange={name => setFilters({ ...filters, name })}
            type={filters.type}
            onTypeChange={type => setFilters({ ...filters, type })}
            typeOptions={CUSTOM_TYPE_OPTIONS}
            showSpaceGroup={false}
            isModal
          />
          <div className="flex-1 overflow-auto">
            <Snippets
              snippetsQuery={snippetsQuery}
              selectedIds={selectedIds}
              handleCheckboxChange={handleCheckboxChange}
              handleSelectAllOnPage={handleSelectAllOnPage}
              allIdsOnPage={allIdsOnPage}
              onChangePage={onChangePage}
              hasFilters={Boolean(filters.name || filters.type)}
            />
          </div>
          <ImportModalFooter
            onImport={handleOnImport}
            selectedCount={selectedIds.length}
            count={snippetsQuery.data?.count || 0}
          />
        </Modal.Content>
      </Modal>
    </UsageContextProvider>
  );
};
